import AnimatedHeading from "../shared/AnimatedHeading";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "E-commerce Director",
      content: "Hither Tech transformed our business with a mobile app that increased customer engagement by 60%. Their technical expertise and strategic approach exceeded our expectations.",
      image: "/avatars/guest-icon.png"
    },
    {
      name: "David Thompson",
      role: "Healthcare Solutions",
      content: "The web platform developed by Hither Tech streamlined our operations and reduced process time by 40%. Their team truly understands how technology can solve business challenges.",
      image: "/avatars/guest-icon.png"
    },
    {
      name: "Michael Roberts",
      role: "Financial Services Manager",
      content: "Security was our primary concern, and Hither Tech delivered a robust solution that gave us peace of mind while meeting all regulatory requirements.",
      image: "/avatars/guest-icon.png"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <h5 className="text-md font-bold text-center mb-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
          Client Success Stories
        </h5>
        <AnimatedHeading text="What Our Clients Say" />
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div>
                  <h4 className="font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-gray-700">"{testimonial.content}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;